export interface OpenExternalTabParams {
  url: string | URL;
  features?: string;
}

export const openExternalTab = ({
  url,
  features = "noopener,noreferrer",
}: OpenExternalTabParams): boolean => {
  if (typeof window === "undefined" || !url) return false;

  return Boolean(window.open(url, "_blank", features));
};

export interface ReserveExternalTabParams {
  placeholderMessage?: string;
}

export interface ReservedExternalTab {
  navigate: (url: string | URL) => void;
  cancel: () => void;
  isAvailable: () => boolean;
}

const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const paintPlaceholder = (tab: Window, message: string): void => {
  const safeMessage = escapeHtml(message);

  try {
    tab.document.write(
      '<!doctype html><meta charset="utf-8">' +
        '<meta name="viewport" content="width=device-width,initial-scale=1">' +
        `<title>${safeMessage}</title>` +
        '<body style="margin:0;display:flex;align-items:center;justify-content:center;' +
        "min-height:100vh;font:16px/1.4 -apple-system,BlinkMacSystemFont,system-ui,sans-serif;" +
        'color:#0f172a;background:#ffffff">' +
        `<p>${safeMessage}</p>`,
    );
    tab.document.close();
  } catch {}
};

export const reserveExternalTab = ({
  placeholderMessage,
}: ReserveExternalTabParams = {}): ReservedExternalTab | null => {
  if (typeof window === "undefined") return null;

  // Sem `noopener` no terceiro argumento: passá-lo devolve null e mata o handle.
  // A mitigação equivalente é anular o opener logo em seguida.
  const tab = window.open("", "_blank");

  if (!tab) return null;

  try {
    tab.opener = null;
  } catch {}

  if (placeholderMessage) paintPlaceholder(tab, placeholderMessage);

  return {
    navigate: (url) => {
      try {
        tab.location.href = String(url);
      } catch {}
    },
    cancel: () => {
      try {
        tab.close();
      } catch {}
    },
    isAvailable: () => {
      try {
        return !tab.closed;
      } catch {
        return false;
      }
    },
  };
};
